// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JC-C","colBig":"styles_colBig__2FK6Q","colSmall":"styles_colSmall__1wqky","shopifyNameWrapper":"styles_shopifyNameWrapper__2_L8o"};